export default "__VITE_ASSET__DeTmTbdC__"